module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"tpvByAcquirerTitle":"Adquirentes mais utilizadas","tpvByAcquirerDescription":"Total do TPV capturado por cada adquirente."},"en-US":{"tpvByAcquirerTitle":"Most used acquirers","tpvByAcquirerDescription":"Total TPV captured by each acquirer."}}')
  delete Component.options._Ctor
}
